var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.iconComponent,{tag:"component",attrs:{"width":_vm.width,"height":_vm.height,"viewBox":("0 0 " + _vm.width + " " + _vm.height),"fill":_vm.iconColor}})}
var staticRenderFns = []

export { render, staticRenderFns }